import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class ClientesService extends ApiService {
  entityType = EntityType.CLIENTE;
  url = 'api/clientes/';
}
